/** Whether Ronan runs inside another page's iframe: embedded Ronan. */
export function isInIframe(): boolean {
  try {
    return window.self !== window.top;
  } catch {
    // Reading window.top throws in a cross-origin iframe.
    return true;
  }
}
